export const OVERVIEW_SOURCE_LABELS = { NEWS_SITES: 'News Sites', WEB_SEARCH: 'Web Search', EPFO: 'EPFO' } as const;
